import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Authentication`
export const LOGIN_URL = `${API_URL}/Authentication`
export const OTP_CODE_VALIDATION = `${API_URL}/Validation`
export const GET_REPORTS = `${API_URL}/GetReports`

export function getUserByToken(token: string) {
    return axios.post(GET_USER_BY_ACCESSTOKEN_URL, {
        api_token: token,
    })
}


